/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBrkQualDetail.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/brk-qual-detail";

export class AutogenModelBrkQualDetail<RowType extends ModelRow> extends Endpoint<RowType, RowBrkQualDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBrkQualDetail extends ModelRow<RowBrkQualDetailFields> {
	constructor(values?: Partial<RowBrkQualDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBrkQualDetailFields {
	brk_qualprofile_id: string;
	company_id: string;
	comparison: string;
	comparison2: string;
	db_values: string;
	detail_type: string;
	display_values: string;
	id: string;
	"item1.company_id": string;
	"item1.comparison_type": string;
	"item1.custom": string;
	"item1.descr": string;
	"item1.field_name": string;
	"item1.id": string;
	"item1.is_active": string;
	"item1.table_name": string;
	"item2.company_id": string;
	"item2.comparison_type": string;
	"item2.custom": string;
	"item2.descr": string;
	"item2.field_name": string;
	"item2.id": string;
	"item2.is_active": string;
	"item2.table_name": string;
	points: number;
	points_type: string;
	profile: string;
	qualification_id: string;
	qualification_id2: string;
	sequence: number;
	value1: string;
	value2: string;
	brk_qual_item_id: string;
	multiselect: boolean;
	saved_values: string;
}

